import _ from "lodash";
import React from "react";
import { SemanticCOLORS, SemanticICONS } from "semantic-ui-react";
import { AbstractGantt } from "./AbstractGantt";
import { GanttUtils } from "./GanttUtils";
import { MissionEventItemRenderer } from "./typeRenderers/MissionEventItemRenderer";
import { MissionItemRenderer } from "./typeRenderers/MissionItemRenderer";
import { TaskItemRenderer } from "./typeRenderers/TaskItemRenderer";

export type IconItem = {
    name: SemanticICONS,
    color?: SemanticCOLORS,
    tooltip?: string;
};

export interface CommonItemProps {
    leftLabel?: string;
    middleLabel?: string;
    rightLabel?: string;
    icons?: IconItem[];
}

export class GanttTypeRenderer extends React.Component<any> {

    render() {
        const { entityUid } = this.props.item;
        if (!entityUid) {
            return <></>;
        }
        const uidTokens = GanttUtils.fromEntityUid(entityUid);
        return <AbstractGantt.Context.Consumer>
            {(ganttProps) => {
                let itemRendererClass = undefined;
                const ganttContextProps = _.omit(ganttProps, 'entities');
                switch (uidTokens.entityName) {
                    case "Task": {
                        itemRendererClass = TaskItemRenderer;
                        break;
                    }
                    case "Mission2": {
                        itemRendererClass = MissionItemRenderer;
                        break;
                    }
                    case "MissionEvent2": {
                        itemRendererClass = MissionEventItemRenderer;
                        break;
                    }
                }
                if (itemRendererClass) {
                    const rendererProps = {
                        ...this.props as any,
                        ganttContextProps: ganttContextProps,
                        entity: GanttUtils.findByUid(GanttUtils.toEntityUid(uidTokens.entityName, uidTokens.id), ganttProps.entities)
                    };
                    return React.createElement(itemRendererClass as any, rendererProps);
                }
                return <></>;
            }
            }
        </AbstractGantt.Context.Consumer>
    }
}
